import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/Layout';
import Markdown from 'components/Markdown';
import Metadata from 'components/Metadata';
import { Heading, Section, Wrapper } from 'components/base';
import { Link, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import ArrowLeft from 'svgs/icons/arrow-left.svg';
import { getCategoryName, getHelpTypeName } from '../HelpCenter.model';
import { btnBack, content, icon } from './HelpCenterTpl.module.scss';

const HelpCenterTpl = ({ data }) => {
  const {
    markdownRemark: {
      html,
      frontmatter: { title, slug, categories, docType },
    },
  } = data;
  const breadcrumb = [
    {
      link: '/help-center',
      text: getHelpTypeName(docType),
    },
    {
      link: `/help-center/categories/${categories[0]}/`,
      text: getCategoryName(categories[0]),
    },
  ];
  const pageTitle = `${title} - ${getHelpTypeName(docType)}`;
  const description = `${title} - ${getCategoryName(
    categories[0]
  )} - ${getHelpTypeName(docType)}`;
  const location = { pathname: slug };
  const structuredData = `
    "mainEntity": [{
      "@type": "Question",
      "name": "${pageTitle}",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": ${JSON.stringify(html)}
      }
    }]
  `;
  return (
    <Layout customizedHeader="helpCenter" helpCenter={{ productName: 'newsleopard' }} location={location}>
      <Metadata title={pageTitle} description={description} atType="FAQPage" structuredData={structuredData} />
      <Section padding="S">
        <Wrapper size="M">
          <Breadcrumb links={breadcrumb} />
          <div className={content}>
            <Heading Tag="h1" size="M" bold marginBottom="Xs">
              {title}
            </Heading>
            <Markdown content={html} />
          </div>
          <div className="mb-l">
            <Link
              className={btnBack}
              to={`/help-center/categories/${categories[0]}/`}
            >
              <ArrowLeft className={icon} />
              返回上層
            </Link>
          </div>
        </Wrapper>
      </Section>
    </Layout>
  );
};

HelpCenterTpl.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      html: PropTypes.string,
      frontmatter: PropTypes.shape({
        slug: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        categories: PropTypes.array.isRequired,
        docType: PropTypes.string.isRequired,
      }),
    }),
  }),
};

export default HelpCenterTpl;

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { slug: { eq: $path } }) {
      html
      frontmatter {
        slug
        title
        categories
        docType
      }
    }
  }
`;
